<template>
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top shadow-sm" id="mainNav">
      <div class="container">
          <a class="navbar-brand" href="#"><img :src="logoUrl" alt="..."></a>

          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" @click="navToggle">
            Menu
            <svg class="svg-inline--fa fa-bars ms-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bars" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z"></path></svg>
          </button>

          <div :class="navbarResponsiveCss" id="navbarResponsive">
            <ul class="navbar-nav ms-auto me-4 my-3 my-lg-0">
              <li class="nav-item" style="top: 0; bottom: 0; margin: auto;" >
                <a class="nav-link me-lg-3" href="https://linktr.ee/pokermanapp" target="_blank">Contact Us</a>
              </li>
              <li class="nav-item" style="top: 0; bottom: 0; margin: auto;" >
                <a class="nav-link me-lg-3" href="#" target="_blank" @click="handleJumpTo('accountDeletion')">Account Deletion</a>
              </li>
              <li class="nav-item">
                <a class="nav-link me-lg-3" href="https://access.gaminglabs.com/Certificate/Index?i=450" target="_blank">
                  <img :src="certifiedUrl" alt="...">
                </a>
              </li>
            </ul>
          </div>
      </div>
    </nav>

</template>

<script>
import logo from '@/assets/images/logo.png'
import certified from '@/assets/images/certified.jpg'
export default {

  name: 'HeaderComp',

  data () {
    return {
      logoUrl: logo,
      displayNav: false,
      certifiedUrl: certified,
      navToggleFlag: false,
      navbarResponsiveCss: 'collapse navbar-collapse'
    }
  },
  created () {
    this.currentActive = this.$route.name
  },
  methods: {
    navToggle () {
      this.navToggleFlag = !this.navToggleFlag

      if (this.navToggleFlag) {
        this.navbarResponsiveCss = 'collapse navbar-collapse show'
      } else {
        this.navbarResponsiveCss = 'collapse navbar-collapse'
      }
    },
    handleJumpTo (name) {
      const { href } = this.$router.resolve({
        name: name
      })
      window.open(href, '_blank')
    }
  }
}

</script>

<style scoped>
header {
    background-color: #2f2e2e;
    color: var(--primary-color);
    position: sticky;
    z-index: 100;
    top: 0;
    left: 0;
}

nav {
  display: -webkit-flex;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  background-color: #2f2e2e;
}

.logo {
  margin-top: 10px;
}

nav .h1 {
    margin-top: 10px;
    width: 270px;
}

ul {
    display: flex;
    list-style: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: solid 1px #2f2e2e;
}

@media only screen and (max-width: 768px) {
    nav {
        flex-direction: column;
        align-items: flex-start;
        padding: 0 20px;
    }

    ul {
        justify-content: space-evenly;
        width: 100%;
        padding: 0;
    }

    li a {
        font-size: 18px;
        border: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/components/header.vue